<template>
  <!-- eslint-disable vue/no-unused-vars -->
  <div class="view-container text-center">
    <div class="text-right cursor-pointer">
      <b-button
        variant="link"
        @click="back"
      >
        <font-awesome-icon icon="times" />
      </b-button>
    </div>

    <h1>Istanze</h1>

    <loading-spinner v-if="loading" />
    <div
      v-else-if="$store.getters.isAuthenticated"
      class="row justify-content-between mx-2 mt-5 mb-2 align-middle"
    >
      <h4>Elenco istanze</h4>
      <div class="text-right">
        <b-button
          variant="primary"
          @click="onNewDocumentClick"
        >
          <font-awesome-icon
            icon="plus"
            class="mr-2"
          />Aggiungi documento
        </b-button>
      </div>
    </div>

    <b-alert
      v-if="!loading && !items.length"
      show
      variant="info"
      class="my-4"
    >
      Non sono presenti istanze in archivio.
      Premere il tasto "<a
        href="#"
        class="alert-link"
        @click="onNewDocumentClick"
      >Aggiungi documento</a>" per inserirne una nuova.
    </b-alert>

    <b-table
      v-else-if="items.length"
      striped
      bordered
      hover
      :fields="fields"
      :items="items"
      :responsive="true"
      :busy="false"
      @row-clicked="onRowClicked"
    >
      <template v-slot:head(icon)>
        <font-awesome-icon
          icon="file-alt"
          size="lg"
          class="text-muted"
        />
      </template>

      <template v-slot:head(dw)>
        <font-awesome-icon
          icon="file-pdf"
          size="lg"
          class="text-muted"
        />
      </template>

      <template v-slot:cell(icon)="data">
        <!-- <font-awesome-icon v-if="data.item.stato === 'A'" icon="pen" size="lg" class="text-primary cursor-pointer"/> -->
        <!-- <font-awesome-icon v-if="data.item.stato === 'C'" icon="search" size="lg" class="text-success cursor-pointer"/> -->
        <font-awesome-icon
          v-if="data.item.ownerista === 'GIQ'"
          icon="check"
          size="lg"
          class="text-success cursor-pointer"
        />
        <font-awesome-icon
          v-else-if="data.item.stato === 'B'"
          icon="pen"
          size="lg"
          class="text-primary cursor-pointer"
        />
        <!-- <font-awesome-icon v-if="data.item.stato === 'P'" icon="pen" size="lg" class="text-primary cursor-pointer"/> -->
        <font-awesome-icon
          v-else-if="isEditable(data.item, 'search')"
          icon="search"
          size="lg"
          class="text-success cursor-pointer"
        />
        <font-awesome-icon
          v-else-if="isEditable(data.item, 'pen')"
          icon="pen"
          size="lg"
          class="text-primary cursor-pointer"
        />
        <font-awesome-icon
          v-else-if="data.item.stato === 'V'"
          icon="search"
          size="lg"
          class="text-success cursor-pointer"
        />
        <pre v-if="isDevelopmentMode">{{data.item.id}}</pre>
      </template>

      <template v-slot:head(download)>
        <font-awesome-icon
          icon="download"
          size="lg"
          class="text-muted"
        />
      </template>

      <template v-slot:cell(descrizioneStato)="data">
        <!-- <span class="font-weight-bold text-uppercase"
          :class="{'text-primary':data.item.stato==='A','text-success':data.item.stato==='C'}"
        > -->
        <span
          class="font-weight-bold text-uppercase"
          :class="{'text-primary':data.item.stato==='B','text-success':data.item.stato==='P','text-success':data.item.stato==='V'}"
        >
          {{ data.value }}
        </span>
      </template>

      <template v-slot:cell(dw)="data">
        <a
          :href="urlIstanza(data.item.id, data.item.ownerista)"
          target="_blank"
          @click.stop
          v-b-tooltip.hover
          title="Scarica il documento"
        >
          <font-awesome-icon
            v-if="data.item.mimeType"
            icon="file-alt"
            size="lg"
            class="text-success cursor-pointer"
          />
        </a>
      </template>

    </b-table>
    <div class="row justify-content-between mx-0 mt-0 mb-2 align-middle">
      <div class="text-right">
        <b-pagination
          :total-rows="totalRows"
          :per-page="perPage"
          v-model="currentPage"
          class="my-0"
        />
      </div>
      <div class="text-right">
        <b-form-group
          description="Per pagina"
          class="mb-0"
        >
          <b-form-select
            :options="pageOptions"
            v-model="perPage"
          />
        </b-form-group>
      </div>
    </div>
    <nuova-istanza-modal ref="modal" />
  </div>
</template>

<script>
// import moment from 'moment'
import moment from 'moment-timezone'
import LoadingSpinner from '@/components/LoadingSpinner'
import NuovaIstanzaModal from '@/components/NuovaIstanzaModal'

const formatValidData = (value, strFormat) => {
  let retValue = ''

  strFormat = strFormat || 'DD/MM/YYYY'

  if (moment(value, 'YYYY-MM-DD', false).isValid()) {
    // retValue = moment(value, 'YYYY-MM-DD', false).format('DD/MM/YYYY')
    retValue = moment(value).locale('it').tz('Europe/Rome').format(strFormat)
  } else if (moment(value, 'YYYY/MM/DD', false).isValid()) {
    // retValue = moment(value, 'YYYY/MM/DD', false).format('DD/MM/YYYY')
    retValue = moment(value).locale('it').tz('Europe/Rome').format(strFormat)
  } else {
    // retValue = moment(value, 'DD/MM/YYYY', false).format('DD/MM/YYYY')
    retValue = moment(value).locale('it').tz('Europe/Rome').format(strFormat)
  }

  // console.log('Data in format', value, retValue, moment(value).locale('it').tz('Europe/Rome').format('DD MMMM YYYY HH:mm'))
  return moment(retValue, strFormat).isValid() ? retValue : ' - '
}

export default {
  components: {
    LoadingSpinner,
    NuovaIstanzaModal
  },
  data () {
    return {
      fields: [
        'icon',
        { key: 'data', label: 'Data', formatter: (value) => { return formatValidData(value) } },
        { key: 'tipoIstanza', label: 'Istanza' },
        { key: 'codiceUib', label: 'Codice BU' },
        { key: 'indirizzo', label: 'Indirizzo' },
        { key: 'descrizioneStato', label: 'Presentazione istanza' },
        // { key: 'statoIstanza', label: 'Stato' },
        { key: 'esitoistanza', label: 'Stato/Esito' },
        // { key: 'tsUltimaModifica', label: 'Ultima modifica', formatter: (value) => { return moment(value).format('DD/MM/YYYY HH:mm:ss') } },
        { key: 'tsUltimaModifica', label: 'Ultima modifica', formatter: (value) => { return formatValidData(value, 'DD/MM/YYYY HH:mm:ss') } },
        { key: 'numeroProtocollo', label: 'Protocollo' },
        'dw'
      ],
      loading: true,
      items: [],
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      pageOptions: [5, 10, 15]
    }
  },

  async created () {
    await this.load()
  },

  computed: {
    isDevelopmentMode () {
      let retValue = process.env.NODE_ENV && process.env.NODE_ENV.trim() === 'development'
      console.log('isDevelopmentMode ', retValue, process.env.NODE_ENV)
      return retValue
    }
  },
  methods: {

    back () {
      this.$router.push({ name: 'home' })
    },

    async load () {
      try {
        this.loading = true
        await this.$store.dispatch('istanze/loadItems')
        this.items = this.$store.state.istanze.items
        // console.log('Istanze caricate: ', this.items)
      } catch (err) {
        // console.log('Errore in load Lista Istanze', this.$store.state)
        this.$ui.showError(err)
        // Se c'è qualsiasi tipo di problema nel caricamento della lista delle istanze esce comunque.
        this.$router.push({ name: 'home' })
      }
      this.loading = false
    },

    async onNewDocumentClick () {
      await this.$refs.modal.open()
    },

    onRowClicked (row) {
      if (row.ownerista !== 'GIQ') {
        this.$router.push({ name: 'istanza', params: { id: row.id } })
      }
    },

    urlIstanza (id, owner) {
      // console.log('urlIstanza', id, owner)
      let urlString
      if (owner) {
        urlString = `/api/istanze/${id}/download?ext=${owner === 'GIQ' ? '1' : '0'}`
      } else {
        urlString = `/api/istanze/${id}/download`
      }
      return urlString
    },
    isEditable (currentRow, idScope) {
      let retValue = false

      // console.log('idScope: ', idScope)
      if (idScope === 'search') {
        retValue = currentRow.editable !== null
      } else {
        retValue = currentRow.stato === 'P' && currentRow.editable !== 'NO'
      }
      // console.log('Riga corrente: ', currentRow.stato, currentRow.editable, retValue)
      return retValue
    }

  }
}
</script>
